import { ITransferReport } from "@pulse-ui/codegen/generated_ts/position_management";
import { IAGTransferEventDataRow } from "../../../AlgoTable.types";
import { getParties } from "../helpers";
import { capitalizeFirstChars } from "@pulse-ui/formatting";
import { v4 as uuidv4 } from "uuid";

export const mapTransferEvent = (rpt: ITransferReport): IAGTransferEventDataRow => {
    const srcGroup = rpt?.src ? getParties(rpt.src) : null;
    const destGroup = rpt?.dest ? getParties(rpt.dest) : null;
    return {
        row_id: uuidv4(),
        id: rpt?.id ?? "-",
        clearing_date: rpt?.clearing_date ?? "-",
        quantity: rpt?.quantity?.toString() ?? "-",
        updated: rpt?.updated ?? "-",
        transfer_type: rpt?.transfer_type?.toString() ? capitalizeFirstChars(rpt.transfer_type.toString().split("_")) : "-",
        txid: rpt?.txid ?? "-",
        transfer_status: capitalizeFirstChars(rpt.status?.toString().split("_") ?? []),
        asset: rpt?.asset ?? "-",
        details: rpt?.details?.toString() ?? "-",
        venue: rpt?.venue ?? "-",
        src_executing_firm: srcGroup?.executing_firm?.party_id ?? "-",
        src_exchange: srcGroup?.exchange?.party_id ?? "-",
        src_customer_account: srcGroup?.customer_account?.party_id ?? "-",
        src_intermediary: srcGroup?.intermediary?.party_id ?? "-",
        src_account_wallet: srcGroup?.account_wallet?.party_id ?? "-",
        src_blockchain_wallet: srcGroup?.blockchain_wallet?.party_id ?? "-",
        dest_executing_firm: destGroup?.executing_firm?.party_id ?? "-",
        dest_exchange: destGroup?.exchange?.party_id ?? "-",
        dest_customer_account: destGroup?.customer_account?.party_id ?? "-",
        dest_intermediary: destGroup?.intermediary?.party_id ?? "-",
        dest_account_wallet: destGroup?.account_wallet?.party_id ?? "-",
        dest_blockchain_wallet: destGroup?.blockchain_wallet?.party_id ?? "-",
    };
}